// extracted by mini-css-extract-plugin
export default {"text":"CheckinInfoCard-module__text___ZTwfJ"};